import { render, staticRenderFns } from "./DataSurvey.vue?vue&type=template&id=9bd5cad8&"
import script from "./DataSurvey.vue?vue&type=script&lang=js&"
export * from "./DataSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports